//Description : Message panel for both spoc and admin

import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../redux/features/appSlice';
import { Cancel, CheckCircle, Close, InsertComment } from '@mui/icons-material';
import { Badge, Box, IconButton, Modal, Stack, TextField, Typography, Button, Tooltip, styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import Axios from '../../../axios/Axios';
import { Component } from 'ag-grid-community';
import { ShowFullText } from '../../Reusable/ShowMoreText';
import axios from 'axios';



export const MessageModalReuse = () => {

    const dispatch = useDispatch();
    const [messageOpen, setMessageOpen] = React.useState(false);
    const [teacherMessages, setTeacherMessages] = useState([]);
    const [replyMessage, setReplyMessage] = useState("");
    const [badgeCount, setBadgeCount] = useState(0)
    const [rowData, setRowData] = useState([]);

    const [sendRef, setSendRef] = useState(false);
    const [escalateRef, setEscalateRef] = useState(false);

    const role = sessionStorage.getItem("role");
    const userId = sessionStorage.getItem("user_id");

    //Get Request: To fetch all messages
    useEffect(() => {
        const controller = axios.CancelToken.source();

        (async () => {
            try {

                switch (role) {
                    case "admin":
                        const adminResponse = await Axios("get", "messages/viewmessages/admin", true, null, { cancelToken: controller.token });
                        if (adminResponse.status === 200) {
                            // let {result1, result2} = adminResponse.data;
                            // let teacherData = result1.map(item => {
                            //     let index = result2.findIndex(ind => item.assigned_spoc_id === ind.user_id);
                            //     return index !== -1 ? {...item, spoc_name: result2[index].username} : {...item, spoc_name: "-"} 
                            // })
                            setTeacherMessages(adminResponse.data.reverse());

                        }
                        break;
                    case "spoc":
                        const spocResponse = await Axios("get", `messages/viewmessage/spoc/${userId}`, true, null, { cancelToken: controller.token });
                        if (spocResponse.status === 200) {
                            setTeacherMessages(spocResponse.data.reverse());

                        }
                        break;
                    default:
                        break;
                }
            } catch (error) {
                if(!axios.isCancel(error)){                 dispatch(
                    showSnackbar({
                        message: "Couldn't able to retrieve Messages",
                        severity: "error"
                    })
                )}

            }
        })();
        return () => {
            controller.cancel();
        }
    }, [sendRef, escalateRef, dispatch, role, userId,messageOpen]);

    //Put Request: Send reply from admin or spoc
    const ReplyToTeacher = async () => {
        try {
            if (replyMessage !== "" && rowData.length !== 0) {
                setSendRef(true)
                let data = {
                    replied_person_id: userId,
                    replied_by: role,
                    reply_message: replyMessage
                }

                const response = await Axios("put", `messages/reply/${rowData[0]["msg_id"]}`, true, data);

                if (response.status === 200) {
                    setReplyMessage("");
                    setRowData([]);
                    dispatch(
                        showSnackbar({
                            message: "Message Sent Successfully",
                            severity: "success"
                        })
                    )
                    setSendRef(false);
                }
            } else {
                if (rowData.length === 0) {
                    dispatch(
                        showSnackbar({
                            message: "Please select the message before sending your response",
                            severity: "error"
                        })
                    )
                } else {
                    dispatch(
                        showSnackbar({
                            message: "Please type your message before sending your response",
                            severity: "error"
                        })
                    )
                }
            }

        } catch (error) {
            setSendRef(false);
            setReplyMessage("")
            dispatch(
                showSnackbar({
                    message: "An error occured while sending message, Please try again",
                    severity: "error"
                })
            )
        }
    }

    //Put Request: Escalate message to admin
    const esclateMessageToAdmin = async () => {
        try {
            if (rowData.length !== 0) {
                setEscalateRef(true)
                const response = await Axios("put", `messages/reply/esclation/${rowData[0]["msg_id"]}`, true, null);

                if (response.status === 200) {
                    dispatch(
                        showSnackbar({
                            message: response.data,
                            severity: "success"
                        })
                    )
                    setEscalateRef(false);
                }
            } else {

                dispatch(
                    showSnackbar({
                        message: "Please select the message before sending your response",
                        severity: "error"
                    })
                )
            }

        } catch (error) {
            setEscalateRef(false);
            dispatch(
                showSnackbar({
                    message: "An error occured while escalating the message, Please try again",
                    severity: "error"
                })
            )
        }
    }


    const columnDefs = [
        role === "spoc" ?
            {
                headerName: "Select",
                // field: "sent_teacher_id",
                // hide: "true",
                filter: true,
                sortable: true,
                checkboxSelection: params => params.data.replied_by === null && !params.data.escalation_status,
            } :
            {
                headerName: "Select",
                // field: "sent_teacher_id",
                // hide: "true",
                filter: true,
                sortable: true,
                checkboxSelection: params => params.data.replied_by === null
            },
        {
            headerName: "Teacher name",
            field: "sent_teacher_name",
            filter: true,
            sortable: true,
        },
        {
            headerName: "Message title",
            field: "msg_title",
            filter: true,
            sortable: true,
            cellRenderer: (params) => {
                return (
                    params.value !== null ?
                        <ShowFullText title={params.value}>
                            <Typography variant='p' sx={{ cursor: "pointer" }}>
                                {params.value}
                            </Typography>
                        </ShowFullText> :
                        "-"
                )
            }
        },
        {
            headerName: "Message",
            field: "msg_description",
            filter: true,
            sortable: true,
            cellRenderer: (params) => {
                return (
                    params.value !== null ?
                        <ShowFullText title={params.value}>
                            <Typography variant='p' sx={{ cursor: "pointer" }}>
                                {params.value}
                            </Typography>
                        </ShowFullText> :
                        "-"
                )
            }
        },
        {
            headerName: "Sent at",
            field: "created_at",
            filter: true,
            sortable: true,
            cellRenderer: (params) => {
                return !!params.value ? params.value.slice(0, 10) : '-'
            }
        },
        {
            headerName: "Reply message",
            field: "reply_message",
            filter: true,
            sortable: true,
            maxWidth: 200,
            cellRenderer: (params) => {
                return (
                    params.value !== null ?
                        <ShowFullText title={params.value}>
                            <Typography variant='p' sx={{ cursor: "pointer" }}>
                                {params.value}
                            </Typography>
                        </ShowFullText> :
                        "-"
                )
            }
        },
        {
            headerName: "Replied by",
            field: "replied_by",
            filter: true,
            sortable: true,
            cellRenderer: (params) => {
                return params.value !== null ? params.value : "-";
            }
        },
        //   {
        //    header:"escalate",
        //    field:"escalate",
        //    filter: true,
        //    sortable: true,
        // //    cellRenderer: BtnCellRenderer,
        // //       cellRendererParams: {
        // //         clicked: function(field) {
        // //           alert(`${field} was clicked`);
        // //         },
        // //       },

        //   },
        {
            headerName: "Status",
            maxWidth: 100,
            editable: false,
            sortable:true,
            filter:true,
            cellRenderer: (params) => {
                // console.log(params.data);
                return (
                    params.data.replied_by !== null && params.data.escalation_status === false ?

                        <Tooltip title="Resolved" placement='right'>
                            <IconButton>
                                <CheckCircle color='success'></CheckCircle>
                            </IconButton>
                        </Tooltip>
                        : params.data.replied_by === null && params.data.escalation_status === true ?

                            <Tooltip title="Escalate" placement='right'>
                                <IconButton>
                                    <CheckCircle color='info'></CheckCircle>
                                </IconButton>
                            </Tooltip> :
                            <Tooltip title="Pending" placement='right'>
                                <IconButton>
                                    <Cancel color='error'></Cancel>
                                </IconButton>
                            </Tooltip>
                )
            },
        }
    ];

    useEffect(() => {
        let msgCount = teacherMessages.filter(message => !message.replied_by || !message.reply_message);
        setBadgeCount(msgCount.length)
    }, [teacherMessages, escalateRef, escalateRef]
    )

    const onSelectionChanged = (event) => {
        setRowData(event.api.getSelectedRows())
        // props.unmappedteachersdata(event.api.getSelectedRows());
    };

    const getStatusCounts = () => {
        const resolvedCount = teacherMessages.filter(
          message => message.replied_by !== null && message.escalation_status === false
        ).length;
      
        const escalateCount = teacherMessages.filter(
          message => message.replied_by === null && message.escalation_status === true
        ).length;
      
        const pendingCount = teacherMessages.filter(
          message => message.replied_by === null && message.escalation_status === false
        ).length;
      
        return { resolvedCount, escalateCount, pendingCount };
      };
      
      const Completed = () => {
        const { resolvedCount, escalateCount, pendingCount } = getStatusCounts();
      
        return (
          <>
            {resolvedCount > 0 && (
              <Tooltip title="Resolved" placement='right'>
                <IconButton>
                  <CheckCircle color='success' />
                  <span>{`(${resolvedCount})`}</span>
                </IconButton>
              </Tooltip>
            )}
      
            {escalateCount > 0 && (
              <Tooltip title="Escalate" placement='right'>
                <IconButton>
                  <CheckCircle color='info' />
                  <span>{`(${escalateCount})`}</span>
                </IconButton>
              </Tooltip>
            )}
      
            {pendingCount > 0 && (
              <Tooltip title="Pending" placement='right'>
                <IconButton>
                  <Cancel color='error' />
                  <span>{`(${pendingCount})`}</span>
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      };
      


    // console.log(completed);
    return (
        <>
            <IconButton
                sx={{ color: "white", mr: "16px" }}
                onClick={() => {
                    setMessageOpen(!messageOpen);
                }}
            >
                <Badge color="error" badgeContent={badgeCount} max={10}>
                    <InsertComment fontSize="medium" />
                </Badge>
            </IconButton>
            <Modal
                open={messageOpen}
                onClose={() => setMessageOpen(false)}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    height: "auto",
                    width: "80vw",
                    bgcolor: 'background.paper',
                    borderRadius: "5px",
                    boxShadow: 24,
                    p: 2,
                }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexDirection: "row"
                        }}
                    >
                        <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexDirection: "row"
                        }}>
                            <Typography variant="h5" component="h1">
                                Messages
                            </Typography>
                            <Box>
                                <p> {Completed()}</p>
                            </Box>
                        </Box>

                        <IconButton onClick={() => {
                            setMessageOpen(false)
                            setReplyMessage("")
                            setRowData([])
                        }}>
                            <Close color='primary' />
                        </IconButton>
                    </Box>
                    <Box sx={{ width: '100%', height: '310px' }}>
                        <AgGridReact
                            className="ag-theme-alpine my-2"
                            rowData={teacherMessages}
                            columnDefs={columnDefs}
                            defaultColDef={{ flex: 1 }}
                            editType="fullRow"
                            // animateRows={true}
                            // suppressClickEdit={true}
                            // onGridReady={onGridReady}
                            onSelectionChanged={onSelectionChanged}
                            // rowMultiSelectWithClick={true}
                            pagination={true}
                            paginationPageSize={5}
                            paginationAutoPageSize={true}
                            groupSelectsChildren={true}
                            suppressRowClickSelection={true}
                            suppressAggFuncInHeader={true}
                        // sideBar={true}
                        ></AgGridReact>
                    </Box>
                    <Stack direction="column" spacing={4} my={4}>
                        <TextField
                            id="outlined-multiline-static"
                            label="Write here..."
                            multiline
                            rows={3}
                            fullWidth
                            value={replyMessage}
                            onChange={(event) => setReplyMessage(event.target.value)}
                        />
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                        <Stack direction="row" spacing={4}>
                            <Button
                                color='inherit'
                                variant="contained"
                                onClick={() => {
                                    setMessageOpen(false)
                                    setReplyMessage("")
                                    setRowData([])
                                }}
                            >
                                CANCEL
                            </Button>

                            <LoadingButton
                                loading={sendRef}
                                variant="contained"
                                onClick={() => {
                                    ReplyToTeacher();
                                    setReplyMessage("");
                                    setRowData([]);
                                }}
                            >
                                Send
                            </LoadingButton>
                        </Stack>

                        <Stack>
                            {role === "spoc" &&
                                <LoadingButton
                                    loading={escalateRef}
                                    variant="contained"
                                    onClick={() => {
                                        esclateMessageToAdmin();
                                        setReplyMessage("")
                                        setRowData([])
                                    }}
                                >
                                    Escalate to admin
                                </LoadingButton>
                            }
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </>
    )
}
